<template>
  <div id="spk-registration-plugin">
    <div>
      <main>

        <RegistrationForm v-show="submitFormStatus == false">
        </RegistrationForm>

        <RegistrationSuccess v-show="submitFormStatus == true">
        </RegistrationSuccess>

      </main>
    </div>
  </div>
</template>

<script>

  import './assets/scss/style.scss';
  import './assets/custom-svg/sprites.svg';

  import RegistrationForm from "@/pages/RegistrationForm";
  import RegistrationSuccess from "@/pages/RegistrationSuccess";
  import { FETCH_FORTNOX } from './store/actions.type';

  export default {
    name: 'App',
    data() {
      return {
        showRequestForm: false
      }
    },
    components: {
      RegistrationForm,
      RegistrationSuccess
    },
    computed: {
      submitFormStatus: {
        get () {
          return this.$store.getters.submitFormStatus;
        }
      }
    },
    mounted() {
      let query = this.$router.history.current.query;
      
      if ('code' in query) {
        const query = Object.assign({}, this.$route.query);
        
        let params = {};
        params['code'] = query.code;
        
        this.$store.dispatch(FETCH_FORTNOX, params);
      } 
    }
  }
</script>
